module.exports = __webpack_public_path__ + "static/media/bulletin_vacancies.ee289174.png";